<template>
	<div class="presentation">
		<div class="swiper-container presentationswiper" style="width: 100vw;height: 100vh;overflow: hidden;">
			<div class="swiper-wrapper">
				<!-- 第一屏 -->
				<div class="swiper-slide swiper-no-swiping" style="width: 100vw;height: 100vh;">
					<Banner></Banner>
				</div>
				<!-- 第二屏 -->
				<div class="swiper-slide swiper-no-swiping" style="  width: 100vw;height: 100vh;">
					<el-scrollbar style="height:100%" ref="anliscrollbar">
						<div style="height:100vh">
							<div class="presentation_li">
								<div class="title_box" style="margin-top:0.3604rem">案例展示</div>
								<div class="option_box">
									<div @click="category(0)" :class="presentationPage == 0?'li liSelected':'li'">
										全部
										<div class="Ground" :style="presentationPage == 0?'opacity: 1;':'opacity: 0;'">
										</div>
									</div>
									<div v-for="item,index in productList" :key="index+'1'">
										<div @click="category(item.productId)"
											:class="presentationPage == item.productId?'li liSelected':'li'" class="li">
											{{item.productTitle}}
											<div class="Ground"
												:style="presentationPage == item.productId?'opacity: 1;':'opacity: 0;'">
											</div>
										</div>
									</div>
								</div>
								<div class="product_box">
									<div @click="productWay(item)" v-for="item,index in exampleList" :key="index+'1'">
										<a :href="item.exampleUrl" target="_blank">
											<div class="li">
												<div class="img_box">
													<img :src="item.exampleImg" alt="">
												</div>
												<h5>
													{{item.exampleTitle}}
												</h5>
												<p>
													<span>{{item.exampleIntro}}</span>
												</p>
											</div>
										</a>
									</div>

								</div>
								<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
									:limit.sync="queryParams.pageSize" @pagination="getList" />
							</div>
							<Footer></Footer>
						</div>
					</el-scrollbar>
				</div>
			</div>
		</div>

		<!-- <div class="banner_box">
      <Banner></Banner>
    </div>
    <div style="height:100vh">
      <div class="presentation_li">
        <div class="title_box"
             style="margin-top:0.3604rem">案例展示</div>
        <div class="option_box">
          <div @click="category(0)"
               :class="presentationPage == 0?'li liSelected':'li'">
            全部
            <div class="Ground"
                 :style="presentationPage == 0?'opacity: 1;':'opacity: 0;'"></div>
          </div>
          <div v-for="item,index in productList"
               :key="index+'1'">
            <div @click="category(item.productId)"
                 :class="presentationPage == item.productId?'li liSelected':'li'"
                 class="li">
              {{item.productTitle}}
              <div class="Ground"
                   :style="presentationPage == item.productId?'opacity: 1;':'opacity: 0;'"></div>
            </div>
          </div>
        </div>
        <div class="product_box">
          <div @click="productWay(item)"
               v-for="item,index in exampleList"
               :key="index+'1'">
            <a :href="item.exampleUrl"
               target="_blank">
              <div class="li">
                <div class="img_box">
                  <img :src="item.exampleImg"
                       alt="">
                </div>
                <h5>
                  {{item.exampleTitle}}
                </h5>
                <p>
                  <span>{{item.exampleIntro}}</span>
                </p>
              </div>
            </a>
          </div>

        </div>
        <pagination v-show="total>0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList" />
      </div>
      <Footer></Footer>
    </div> -->
	</div>

</template>

<script>
	import {
		mapMutations
	} from 'vuex';
	import Footer from "@/components/footer.vue";
	import Banner from "@/components/banner.vue";
	import {
		listExample,
		getExample
	} from "@/api/presentation";
	import {
		listProduct
	} from "@/api/product";
	export default {
		computed: {
			presentationPage: {
				get() {
					return this.$store.state.presentationPage
				},
				set(value) {
					this.$store.commit('putpresentationPage', value)
				}
			},
			presentationIds: {
				get() {
					return this.$store.state.presentationIds
				},
				set(value) {
					this.$store.commit('putpresentationIds', value)
				}
			}
		},
		components: {
			Footer,
			Banner
		},
		data() {
			return {
				isV: true,
				// 成功案例表格数据
				exampleList: [],
				// 总条数
				total: 0,
				// 产品管理表格数据
				productList: [],
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 9,
					productId: null,
					exampleTitle: null,
					createTime: null
				},

				scrollTop: 0,
				presentationswiperId: '',
				presentationswiper: '',
				jieliu: true,
			};
		},
		created() {
			this.queryParams.productId = this.$route.query.id
			if (this.queryParams.productId != undefined) {
				this.putpresentationPage(this.queryParams.productId)
			}
			this.getProductList();
			this.getList();
		},
		watch: {
			presentationPage: {
				handler(e) {
					this.getList()
				}
			},
			presentationswiperId: {
				handler(e) {
					if (e == 1) {
						this.$refs.anliscrollbar.wrap.scrollTop = 1
						this.presentationswiper.disableMousewheelControl()
					}
				}
			}
		},
		mounted() {
			var _this = this
			this.$refs.anliscrollbar.wrap.onscroll = (e) => {
				_this.scrollTop = e.target.scrollTop
				if (e.target.scrollTop == 0) {
					_this.presentationswiper.slidePrev()
					_this.presentationswiper.enableMousewheelControl()
				}
			}
			if (_this.presentationPage !== 0) {
				_this.presentationswiperId = 1
			}
			this.presentationswiper = new Swiper('.presentationswiper', {
				initialSlide: _this.presentationswiperId,
				direction: 'vertical',
				loop: false, //不循环
				spaceBetween: 0, // swiper-slide 间的距离为0
				autoplay: false, // 不自动切换
				speed: 700, // 每次切换时长
				// scrollbar: '.swiper-scrollbar', // 滚动条
				mousewheelControl: true, // 开启鼠标切换
				noSwiping: true, // 开启不允许切换
				onSlideChangeEnd: function(swiper) {
					_this.presentationswiperId = swiper.activeIndex
				}

			})
		},
		methods: {
			...mapMutations(['putpresentationPage']),

			category(row) {
				this.putpresentationPage(row)
				if (row > 0) {
					this.queryParams.productId = row;
				} else {
					this.queryParams.productId = null;
				}
				this.getList();
			},
			/** 查询成功案例列表 */
			getList() {
				this.queryParams.productId = this.presentationPage
				listExample(this.queryParams).then(response => {
					this.exampleList = response.rows;
					this.total = response.total;
				});
			},
			getProductList() {
				listProduct({}).then(response => {
					this.productList = response.rows;
				});
			},
			productWay(row) {
				let routeData = this.$router.resolve({
					path: "/presentation/details",
					query: {
						exampleId: row.exampleId
					}
				});
				window.open(routeData.href, '_blank');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.presentation {
		text-align: center;

		.title_box {
			display: inline-block;
			position: relative;
			font-size: 0.2103rem;
			font-family: MicrosoftYaHei;
			color: #000;
			opacity: 1;
		}

		.title_box::before {
			content: "";
			position: absolute;
			left: -0.4083rem;
			top: 58%;
			transform: translateY(-50%);
			width: 0.2083rem;
			height: 0.2188rem;
			background-image: url("../../static/images/icon/title_left.png");
			background-size: 100% 100%;
		}

		.title_box::after {
			content: "";
			position: absolute;
			right: -0.4083rem;
			top: 58%;
			transform: translateY(-50%);
			width: 0.2083rem;
			height: 0.2188rem;
			background-image: url("../../static/images/icon/title_right.png");
			background-size: 100% 100%;
		}

		.title_info {
			font-size: 0.1146rem;
			font-family: MicrosoftYaHei;
			line-height: 0.2083rem;
			color: #999999;
			opacity: 1;
		}

		.banner_box {
			width: 100vw;
			height: 100vh;
		}

		.presentation_li {
			overflow: hidden;
			margin-top: 0.2563rem;

			.option_box {
				padding: 0rem 1.875rem;
				display: flex;
				justify-content: space-between;
				margin-top: 0.2604rem;

				.li {
					position: relative;
					width: 0.7083rem;
					height: 0.2969rem;
					border: 0.0052rem solid #999999;
					opacity: 1;
					border-radius: 0px;
					font-family: MicrosoftYaHei;
					font-weight: 400;
					line-height: 0.2969rem;
					color: #444444;
					font-size: 0.0833rem;
					opacity: 1;
					transition: 0.3s;
					cursor: pointer;

					.Ground {
						opacity: 0;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0rem;
						left: 0rem;
						z-index: -1;
						transition: 0.3s;
						background: linear-gradient(270deg, #e71623 0%, #f5c071 100%);
					}
				}

				.liSelected {
					border-color: #00000000;
					color: #fff !important;
				}

				.li:hover {
					color: #fff;

					.Ground {
						opacity: 1 !important;
					}
				}
			}

			.product_box {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				padding: 0.1021rem 1.875rem;

				.li {
					width: 1.8075rem;
					height: 1.5575rem;
					background: #ffffff;
					box-shadow: 0px 0px 0.0781rem rgba(0, 0, 0, 0.2);
					opacity: 1;
					border-radius: 0px;
					margin-top: 0.2083rem;
					padding: 0.0625rem;

					.img_box:hover {
						img {
							transform: scale(1.5);
						}
					}

					.img_box {
						overflow: hidden;
						height: 1.2031rem;
						background-color: #fff;

						img {
							transition: 0.3s;
						}
					}

					h5 {
						font-size: 0.0938rem;
						font-family: Microsoft YaHei;
						font-weight: bold;
						color: #000000;
						opacity: 1;
						margin: 0.0542rem 0rem;
					}

					p {
						font-size: 0.0729rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #666666;
						opacity: 1;

						span {
							margin: 0 0.0521rem;
						}
					}
				}
			}

			.paging {
				text-align: center;
				padding: 0.1021rem 1.875rem;

				span {
					display: inline-block;
					width: 0.4688rem;
					height: 0.2031rem;
					background: #ffffff;
					border: 0.0052rem solid #dbdbdb;
					opacity: 1;
					border-radius: 0.0208rem;
					line-height: 0.2031rem;
					margin: 0rem 0.026rem;
					cursor: pointer;
					font-size: 0.0729rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #999999;
					opacity: 1;
					user-select: none;
					background-color: #fff;
					transition: 0.3s;
				}

				.spanselect {
					background-color: #ff6100;
					color: #fff;
				}
			}
		}

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>